// extracted by mini-css-extract-plugin
export var container = "_47-0";
export var containerTopRight = "_47-1";